import { createRef, useEffect, useRef, useState } from "react"
import ClusterModel from "../model/ClusterModel";
import BeaconModel from "../model/BeaconModel";
import { Button, Col, Form, Row } from "react-bootstrap";
import beaconResultType from "../model/beaconResultType";
import MoveList from "./MoveList";

type propsType = {
    clusterData: ClusterModel[]
    beaconData: BeaconModel[]
    clusterNo: string
    beaconlogs: beaconResultType[]
    startDetectTime: string
    endDetectTime: string
}

type beaconPositionType = {
    id: string
    name: string
    x: number
    y: number
}



const Canvas = (props: propsType) => {
    let imgurl:string
    let spos: number = 9999;
    let spos_buf: number = 9999;
    let epos: number = 9999;
    let animetionCallbackId: number;
    let beaconPositionArray: beaconPositionType[] = [];
    const [sBeaconPositionArray, setBeaconPositionArray] = useState<beaconPositionType[]>([]);
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const canvasRef_Line = useRef<HTMLCanvasElement>(null);
   // const canvasRef_Name = useRef<HTMLCanvasElement>(null);
    const canvasRef_Icon = useRef<HTMLCanvasElement>(null);
    const tooltipRef = useRef<HTMLDivElement>(null);
    
    const [mBeforeHeight, setmBeforeHeight] = useState<number>(0);
    const [mBeforeWidth, setmBeforeWidth] = useState<number>(0);
    const [mAfterWidth, setmAfterWidth] = useState<number>(0);
    const [mAfterHeight, setmAfterHeight] = useState<number>(0);
   
    let nextStartLogDate: string;
    const [sNextStartLogDate, setNextStartLogDate] = useState<string>("");
    let loopHandler: number;
    const [sLoopHandler, setLoopHandler] = useState<number>(0);
    const [moveLists, setMovelist] = useState<string[]>([]);
    const moveList: string[] = [];
    const [intervalTime, setIntervalTime] = useState<number>(1000);
    const [lineLength, setLinelength] = useState<number>(10);
    const [speed, setSpeed] = useState<number>(10);
    let line = lineLength;
    let startTime: Date;
    let endTime: Date;
    let moveTime: number;
    let moveCount: number;
    const [sMoveTime, setMoveTime] = useState<number>(0);
    const [sMoveCount, setMoveCount] = useState<number>(0);
    const chara = new Image();
    chara.src = "../image/human.png"

    const [sLogRange, setLogRage] = useState<number>(60);
   
    const getMapContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef.current;
        return canvas.getContext('2d');
    }

    const getLineContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef_Line.current;
        return canvas.getContext('2d');
    }

    /*
    const getTextContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef_Name.current;
        return canvas.getContext('2d');
    }
    */

    const getIconContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef_Icon.current;
        return canvas.getContext('2d');
    }

    const setMapImage = () => {
       
        getBeaconPoint()
        const ctx: CanvasRenderingContext2D = getMapContext();
        //const ctx_name: CanvasRenderingContext2D = getTextContext();
        const ctx_line: CanvasRenderingContext2D = getLineContext();
        const ctx_icon: CanvasRenderingContext2D = getIconContext();
        //Map Draw
        imgurl = props.clusterData[Number(props.clusterNo)].image
 
        const img = new Image()
        img.src = imgurl
        

        img.onload = () => {
            const { naturalHeight: beforeHeight, naturalWidth: beforeWidth } = img
           // console.log("H%ixW%i", beforeHeight, beforeWidth)
            const afterWidth: number = 800
            const afterHeight: number = Math.floor(beforeHeight * (afterWidth / beforeWidth))

            setmBeforeHeight(beforeHeight);
            setmBeforeWidth(beforeWidth);
            setmAfterHeight(afterHeight);
            setmAfterWidth(afterWidth);

            //console.log("mAfterHeight:" + mAfterHeight);
            //console.log("mAfterWidth:" + mAfterWidth);

            //各キャンバスのサイズを揃える
            ctx.canvas.width = afterWidth;
            ctx.canvas.height = afterHeight;
            
            ctx_line.canvas.width = afterWidth;
            ctx_line.canvas.height = afterHeight;

            /*
            ctx_name.canvas.width = afterWidth;
            ctx_name.canvas.height = afterHeight;
            */

            ctx_icon.canvas.width = afterWidth;
            ctx_icon.canvas.height = afterHeight;


            //setMoveListHeight(String(afterHeight));

            let canvasContainer = document.getElementById("canvas-container") as HTMLDivElement;
            let cvHeight: string = String(ctx.canvas.height) + "px"
            canvasContainer.style.height = cvHeight

            ctx.drawImage(img, 0, 0, beforeWidth, beforeHeight, 0, 0, afterWidth, afterHeight)
            
            
            beaconPositionArray.forEach((beaconPosition: beaconPositionType) => {
                ctx.beginPath();
               // console.log("X:" + (beaconPosition.x * afterWidth) / beforeWidth)
               // console.log("Y:" + (beaconPosition.y * afterHeight) / beforeHeight)

                ctx.arc((beaconPosition.x * afterWidth) / beforeWidth, (beaconPosition.y * afterHeight) / beforeHeight, 7, 0 * Math.PI / 180, 360 * Math.PI / 180, false);
                ctx.fillStyle = "#AADCE7";
                ctx.fill();
                ctx.strokeStyle = "#00A2FF";
                ctx.lineWidth = 3;
                ctx.stroke();


                /*
                // テキストの背景を描画
                const text = beaconPosition.name; // 描画するテキスト
                const textWidth = ctx_name.measureText(text).width; // テキストの幅を取得
                const textX = (beaconPosition.x * afterWidth) / beforeWidth;
                const textY = (beaconPosition.y * afterHeight) / beforeHeight - 12;

                let textOffset = textWidth / 2
                ctx_name.beginPath(); 
                // テキストの背景を描画
                let backgroundColor = "rgba(" + [0, 255, 255, 0.4] + ")";
                ctx.fillStyle = backgroundColor;
                ctx.fillRect(textX - textOffset , textY - 15, textWidth, 20);


                ctx_name.font = "bold 13px Roboto medium"
                ctx_name.textAlign = "center"

                //let textOffset = textWidth / 2
                if ((textX - textOffset) > 0 ) {
                    textOffset = 0 
                }
                
                ctx_name.textBaseline = "bottom"
                ctx_name.fillStyle = "#000000";
                ctx_name.fillText(text, textX + textOffset, textY)
                */
            
            })

            //const canvas: HTMLCanvasElement = document.getElementById("mainCanvas") as HTMLCanvasElement;
            //const tooltip: HTMLElement = document.getElementById("tooltip") as HTMLElement;
            const canvas: HTMLCanvasElement = canvasRef_Icon.current as HTMLCanvasElement;
            const tooltip:HTMLDivElement = tooltipRef.current as HTMLDivElement;
            canvas.addEventListener("mousemove", (event) => {
                const mouseX = event.clientX - canvas.getBoundingClientRect().left;
                const mouseY = event.clientY - canvas.getBoundingClientRect().top;
              
                beaconPositionArray.forEach((circle) => {
                  if (isMouseOverCircle(mouseX, mouseY, circle, afterHeight, beforeHeight, afterWidth, beforeWidth)) {
                    // マウスがサークル上にある場合の処理
                    canvas.style.cursor = "pointer"; // マウスポインタを変更
              
                    //const tooltip = tooltipRef.current as HTMLDivElement;
                    // ツールチップの位置を設定
                    tooltip.style.display = "block";
                    tooltip.style.left = event.pageX + "px";
                    tooltip.style.top = event.pageY + "px";
              
                    // ツールチップにサークルの名前を表示
                    tooltip.innerHTML = circle.name;
                
                  }
                });
              
                if (!beaconPositionArray.some((circle) => isMouseOverCircle(mouseX, mouseY, circle, afterHeight, beforeHeight, afterWidth, beforeWidth))) {
                  // マウスがどのサークルにもない場合の処理
                  canvas.style.cursor = "default"; // マウスポインタを元に戻す
                  tooltip.style.display = "none"; // ツールチップを非表示にする
                }
              });
            
        }
        ctx.save(); 
    }

    const isMouseOverCircle = (x: number, y: number, circle: beaconPositionType, afterHeight: number, beforeHeight: number, afterWidth: number, beforeWidth: number): boolean => {
        const distance = Math.sqrt((x - (circle.x * afterWidth) / beforeWidth) ** 2 + (y - (circle.y * afterHeight) / beforeHeight) ** 2);
        return distance <= 10;
    }

    const getBeaconPoint = () => {
        console.log("getBeaconPoint")
        beaconPositionArray.length = 0;
        props.clusterData[Number(props.clusterNo)].beacons.forEach ((clusterBeacon: any) => {
            props.beaconData.forEach((beacon: BeaconModel) => {
                if(clusterBeacon.id === beacon.id) {
                  //  console.log(beacon.name)
                  //  console.log(beacon.x)
                  //  console.log(beacon.y)
                    let position: beaconPositionType = {
                        id: beacon.id,
                        name: beacon.name, 
                        x: beacon.x,
                        y: beacon.y}
                    
                    beaconPositionArray.push(position)
                }
            })
        })

        setBeaconPositionArray(beaconPositionArray);
    }

    const drawFirstPoint = (sPosition: number) => {
        let startX = (sBeaconPositionArray[sPosition].x * mAfterWidth) / mBeforeWidth;
        let startY = (sBeaconPositionArray[sPosition].y * mAfterHeight) / mBeforeHeight;
        let ctx_icon = getIconContext();
        
        ctx_icon.clearRect(0,0, ctx_icon.canvas.width, ctx_icon.canvas.height);
        ctx_icon.drawImage(chara, startX, startY - 10, 32, 32);
    }
    
    const drawDeviceMove = (sPosition: number, ePosition: number) => {
        spos = sPosition;
        epos = ePosition;
        // アニメーションを開始
        animate();
    }

    function calculateAngle(x1: number, y1: number, x2: number, y2: number): number {
        // 始点から終点までのXおよびY座標の差を計算
        const dx = x2 - x1;
        const dy = y2 - y1;
    
        // Math.atan2()を使用して角度を計算し、ラジアンから度に変換
        const angleInRadians = Math.atan2(dy, dx);
        const angleInDegrees = angleInRadians * (180 / Math.PI);
    
        // 0から360度の範囲に角度を調整
        const normalizedAngle = (angleInDegrees + 360) % 360;
    
        return normalizedAngle;
    }

    function calculateAngle360(x1: number, y1: number, x2: number, y2: number): number {
        // 始点から終点までのXおよびY座標の差を計算
        const dx = x2 - x1;
        const dy = y2 - y1;
    
        // Math.atan2()を使用して角度をラジアンで計算
        const angleInRadians = Math.atan2(dy, dx);
    
        // ラジアンから度に変換
        let angleInDegrees = angleInRadians * (180 / Math.PI);
    
        // 負の角度を正に変換
        if (angleInDegrees < 0) {
            angleInDegrees += 360;
        }
    
        return angleInDegrees;
    }

   
 
    // アニメーションループ
    function animate() {
       
        //アニメーションフラグ
        let animationFlg: boolean = false;
        // 初期位置
        let startX = (sBeaconPositionArray[spos].x * mAfterWidth) / mBeforeWidth;
        let startY = (sBeaconPositionArray[spos].y * mAfterHeight) / mBeforeHeight;
        let endX = (sBeaconPositionArray[epos].x * mAfterWidth) / mBeforeWidth;
        let endY = (sBeaconPositionArray[epos].y * mAfterHeight) / mBeforeHeight;
        let angleInDegrees = calculateAngle360(startX, startY, endX, endY);
        

        //let ctx = getLineContext();
        // Canvasをクリア
        //ctx.clearRect(0, 0, 800, 800);

        // 矢印付きの線を描画
        animationFlg = drawArrowLine(startX, startY, endX, endY, line, angleInDegrees);

        // 線の長さを更新
        line += speed;

        if (animationFlg) {
            animetionCallbackId = requestAnimationFrame(animate);
        } else {
            startY = 0;
            startY = 0;
            line = lineLength;
            cancelAnimationFrame(animetionCallbackId);
        }
    }

    // 矢印付きの線を描画する関数
    function drawArrowLine(x: number, y: number, lastX: number, lastY: number, length: number, angleDegrees: number):boolean {
        let returnflg = true;
        let ctx = getLineContext();
        let ctx_icon = getIconContext();
        
        const angleRadians = (angleDegrees * Math.PI) / 180;

        
        const endX = x + length * Math.cos(angleRadians);
        const endY = y + length * Math.sin(angleRadians);

        //console.log("cos1:" + Math.cos(angleRadians))
        //ctx.save();
        //ctx.globalCompositeOperation = "source-atop";

        

        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(endX, endY);
        //ctx.lineTo(lastX, lastY);
        ctx.strokeStyle = "red";
        ctx.lineWidth = 2;
        ctx.stroke();


        ctx_icon.clearRect(0,0, ctx_icon.canvas.width, ctx_icon.canvas.height);
        ctx_icon.drawImage(chara, endX, endY - 10, 32, 32);

        
        let xAbs = Math.abs(Math.cos(angleRadians) - 0.00001);
        let yAbs = Math.abs(Math.sin(angleRadians) - 0.00001);

        if (xAbs <= 0.0001) {
            if (Math.sin(angleRadians) < 0) {
                if (endY < lastY) {
                    returnflg = false
                }
            } else {
                if (endY > lastY) {
                    returnflg = false
                }

            }

        } else if (yAbs <= 0.0001) {
            if (Math.cos(angleRadians) < 0) {
                if (endX < lastX) {
                    returnflg = false
                }
            } else {
                if (endX > lastX) {
                    returnflg = false
                }

            }
        } else {
            if (Math.cos(angleRadians) > 0 && Math.sin(angleRadians) < 0) {
                if (endX > lastX && endY < lastY) {
                    returnflg = false
                }
            }
    
            if (Math.cos(angleRadians) > 0 && Math.sin(angleRadians) > 0) {
                if (endX > lastX && endY > lastY) {
                    returnflg = false
                }
            }
            
            if (Math.cos(angleRadians) < 0  && Math.sin(angleRadians) > 0) {
                if (endX < lastX && endY > lastY) {
                    returnflg = false
                }
            }
    
            if (Math.cos(angleRadians) < 0  && Math.sin(angleRadians) < 0) {
                if (endX < lastX && endY < lastY ) {
                    returnflg = false
                }
            }
        }


        if (!returnflg) {
            drawArrow(ctx, endX, endY, angleRadians);
        }

        ctx.restore();

        return returnflg
    }

    function drawArrow(ctx: CanvasRenderingContext2D, endX: number, endY: number, angleRadians: number) {
        const arrowLength = 10; // 矢印の長さ

        ctx.beginPath();
        ctx.moveTo(endX - arrowLength * Math.cos(angleRadians - Math.PI / 6), endY - arrowLength * Math.sin(angleRadians - Math.PI / 6));
        ctx.lineTo(endX, endY);
        ctx.lineTo(endX - arrowLength * Math.cos(angleRadians + Math.PI / 6), endY - arrowLength * Math.sin(angleRadians + Math.PI / 6));
        ctx.fillStyle = "red";
        ctx.fill();
    }

    function canvasClear() {
        let line_ctx = getLineContext();
        let map_ctx = getMapContext();
        //let text_ctx = getTextContext();

        line_ctx.clearRect(0, 0, line_ctx.canvas.width, line_ctx.canvas.height);
        map_ctx.clearRect(0, 0, map_ctx.canvas.width, map_ctx.canvas.height);
        //text_ctx.clearRect(0, 0, text_ctx.canvas.width, text_ctx.canvas.height);
    }


    const getNearBeacon = (startLogDate: string) => {
        let beaconLogArray: beaconResultType[] = [];
        let startBeaconLogDate = new Date(startLogDate);
        let endBeaconlogDate = new Date(startLogDate);

        //何分後を範囲とするか
        //endBeaconlogDate.setMinutes(endBeaconlogDate.getMinutes() + 1);
        endBeaconlogDate.setSeconds(endBeaconlogDate.getSeconds() + sLogRange);
        moveList.push(startBeaconLogDate.toLocaleString());
        nextStartLogDate = endBeaconlogDate.toString();
        setNextStartLogDate(nextStartLogDate);
        console.log("startDate:" + startBeaconLogDate);
        console.log("endDate:" + endBeaconlogDate);

        props.beaconlogs.forEach((value: beaconResultType) => {
            let valuedate = new Date(value.detected);
            if(valuedate.getTime() >= startBeaconLogDate.getTime() && valuedate.getTime() <= endBeaconlogDate.getTime() ) {
                beaconLogArray.push(value);
            }        
        })

        let nearbeacon_buf: beaconResultType[] = [];
        let nearbeacon: beaconResultType;
        let startTime: Date = new Date(0)
        let firstTime: Date = new Date(0)
        let xyflg: boolean = false

        for (let idx = beaconLogArray.length -1 ; idx >= 0 ; idx--) {
            console.log("searchBeaconLogs")
            //基準になる時刻を取得
            if (startTime.getTime() === firstTime.getTime()) {
                startTime = new Date(beaconLogArray[idx].detected);
                nearbeacon_buf.push(beaconLogArray[idx]);
            } else {
                //同じ時刻のログを収集
                if (startTime.getTime() === new Date(beaconLogArray[idx].detected).getTime()) {
                    nearbeacon_buf.push(beaconLogArray[idx]);  
                } else {
                    //時刻が変わった
                    //同じ時刻のログは1件以上ある？
                    if (nearbeacon_buf.length >= 1) {
                        //ソート
                        nearbeacon_buf.sort((a,b) => {
                            return a.rssi > b.rssi ? -1 : 1;
                        })
                        //最強は１つ？
                        if (nearbeacon_buf.length >= 2) {
                            //ソートしてるので先頭と次が違う場合は先頭が最強
                            for (let idx = 0; idx <= nearbeacon_buf.length -1; idx++) {
                                
                                //if (nearbeacon_buf[idx].rssi !== nearbeacon_buf[idx + 1].rssi) {
                                   
                                    //座標はあるか？
                                    for (let idx2 = 0; idx2 <= sBeaconPositionArray.length -1; idx2++) {
                                        if (sBeaconPositionArray[idx2].id === nearbeacon_buf[idx].beacon_id) {
                                            xyflg = true;
                                            break;
                                        }
                                    }
                                    if (xyflg) {
                                        //これが今回のビーコン
                                        nearbeacon = nearbeacon_buf[idx]
                                        break;
                                    }
                                //}
                            }
                            
                        
                        } else {
                            
                             //座標はあるか？
                            for (let idx2 = 0; idx2 <= sBeaconPositionArray.length -1; idx2++) {
                                if (sBeaconPositionArray[idx2].id === nearbeacon_buf[0].beacon_id) {
                                    xyflg = true;
                                    break;
                                }
                            }
                            if (xyflg) {
                                //これが今回のビーコン
                                nearbeacon = nearbeacon_buf[0]
                            }
                        }

                        if (nearbeacon! != null) {
                            console.log("nearBeacon:" + nearbeacon.beacon_id)
                            sBeaconPositionArray.forEach((value: beaconPositionType, index: number) => {
                                if (value.id === nearbeacon.beacon_id) {
                                    if (spos === 9999) {
                                        spos = index;
                                        drawFirstPoint(spos);
                                        moveList.pop();
                                        moveList.push(startBeaconLogDate.toLocaleString() + " " + sBeaconPositionArray[spos].name + "から開始")
                                        //drawDeviceMove(spos, spos);
                                    } else {
                                        if (spos_buf !== 9999) {
                                            spos = spos_buf;
                                        }
                                        epos = index;
                                        console.log("spos:" + spos)
                                        console.log("epos:" + epos)
                                        if (spos !== epos) {
                                            console.log("drawDeviceMove:(" + spos + "," + epos + ")")
                                            moveList.pop();
                                            moveList.push(startBeaconLogDate.toLocaleString() + " " + sBeaconPositionArray[spos].name + "から" 
                                            + sBeaconPositionArray[epos].name + "へ移動")
                                            drawDeviceMove(spos, epos);
                                            spos_buf = epos;
                                        }
                                        
                                    }
                                    
                                }
                            })
                        }
                        break;
                    }

                    //次の同時刻の為に
                    startTime = new Date(beaconLogArray[idx].detected);
                    nearbeacon_buf.length = 0;
                    nearbeacon_buf.push(beaconLogArray[idx]);
                }
            }           
        }
        

        setMovelist([...moveLists, ...moveList])
    } 
   
    useEffect(() => {
        console.log("useEffect")
        canvasClear();
        setMapImage();

    },[]);

    const setMoveListHeight = (fixHeight: string) => {
        const listGroup = document.getElementById("list");
        
        if (listGroup) {
            listGroup.style.height = fixHeight + "px";
            console.log("list:" + listGroup.style!.height)
        }   
    }

   
    const playFunction = (looph: number) => {
        
        const playButton = document.getElementById("playButton") as HTMLButtonElement;
        const list = document.getElementById("list");
        const selectInterval = document.getElementById("selectInterval") as HTMLSelectElement
        const selectLogRange = document.getElementById("selectLogRange") as HTMLSelectElement

        
       
        if (playButton.textContent === "軌跡を見る") {
            selectInterval.disabled = true;
            selectLogRange.disabled = true;
            //開始時刻と終了時刻の差分を分で算出
            startTime = new Date(props.startDetectTime);
            endTime = new Date(props.endDetectTime);
            moveTime = Math.abs(endTime.getTime() - startTime.getTime()) / (sLogRange * 1000);
            moveCount = 0;
        } else if (playButton.textContent === "停止中") {
            moveTime = sMoveTime;
            moveCount = sMoveCount;
            nextStartLogDate = sNextStartLogDate;
            selectInterval.disabled = true;
            selectLogRange.disabled = true;
        }
        
        

        if (playButton.textContent === "再生中") {
            clearInterval(sLoopHandler);
            playButton.textContent = "停止中";
            selectInterval.disabled = false;
            selectLogRange.disabled = false;
           
        } else {

            if (playButton.textContent === "もう一度見る") {
                selectInterval.disabled = true;
                selectLogRange.disabled = true;
                canvasClear();
                setMapImage();
                //開始時刻と終了時刻の差分を分で算出
                startTime = new Date(props.startDetectTime);
                endTime = new Date(props.endDetectTime);
                moveTime = Math.abs(endTime.getTime() - startTime.getTime()) / (sLogRange * 1000);
                moveCount = 0;
               
                playButton.textContent = "再生中";
                let child = list?.childNodes;
                for (let i: number = child!.length - 1; i >= 0; i--) {
                    list?.removeChild(child![i]);
                }
                
                 
            } else {
                playButton.textContent = "再生中";
            }

            loopHandler = Number(setInterval(() => {
                if (moveCount < moveTime) {
                    console.log("getNearBeacon")
                    
                    if (moveCount === 0) {
                        getNearBeacon(props.startDetectTime);
                    } else {
                        getNearBeacon(nextStartLogDate);
                    }
                    setMoveCount(moveCount);
                    setMoveTime(moveTime);
                    moveCount++;
                    list?.scrollTo(0, list.scrollHeight)
                   
                   
                } else {
                    list?.scrollTo(0, list.scrollHeight)
                    clearInterval(loopHandler);
                    moveCount = 0;
                    playButton.textContent = "もう一度見る";
                    selectInterval.disabled = false;
                    selectLogRange.disabled = false;
                   
                }
            }, intervalTime)); // アニメーション速度を調整する場合、ここのミリ秒を変更
            
            setLoopHandler(loopHandler);
        }
    }

    const setLoopInterval = (time: string) => {
        console.log("getNearLoop:" + beaconPositionArray.length)
        setIntervalTime(Number(time));
          // 線の長さ、角度、速度
        if (Number(time) >= 1000) {
            setLinelength(Math.trunc(10000 / Number(time)));
            setSpeed(Math.trunc(10000 / Number(time)));
        } else if (Number(time) >= 100){
            setLinelength(Math.trunc(1000 / Number(time)));
            setSpeed(Math.trunc(1000 / Number(time)));
        } else if (Number(time) >= 10){
            setLinelength(Math.trunc(50 / Number(time)));
            setSpeed(Math.trunc(50 / Number(time)));
        }
        
        
    }

    return(
        <div>
            {
            /*    debug
            <div>
            
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(0,3)}>line1(0to3)</Button>
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(3,0)}>line2(3to0)</Button>

                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(1,3)}>line3(1to3)</Button>
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(3,1)}>line4(3to1)</Button>
                
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(2,3)}>line5(2to3)</Button>
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(3,2)}>line6(3to2)</Button>

                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(1,2)}>line7(1to2)</Button>
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(2,1)}>line8(2to1)</Button>

                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(2,0)}>line9(2to0)</Button>
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(0,2)}>line10(0to2)</Button>
                
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(0,1)}>line11(0to1)</Button>
                <Button className="mt-3 mb-2" onClick={(e) => drawDeviceMove(7,6)}>line12(1to0)</Button>

                <Button className="mt-3 mb-2" onClick={(e) => setMapImage()}>setMap</Button>
                <Button className="mt-3 mb-2" onClick={(e) => canvasClear()}>Clear</Button>
                <Button className="mt-3 mb-2" onClick={(e) => getNearBeacon(props.startDetectTime)}>getNearBeacon</Button>
                
            </div>
            */
    }




            <div id="canvas-container" className="canvas-container">
                <canvas className="canvas1" width={800} height={800} ref={canvasRef}></canvas>
                <canvas className="canvas2" width={800} height={800} ref={canvasRef_Line}></canvas>
                {
                    //<canvas className="canvas3" width={800} height={800} ref={canvasRef_Name}></canvas>
                }
                
                <canvas className="canvas4" width={800} height={800} ref={canvasRef_Icon}></canvas>
                
            </div>
            
            <div className="description1" id="tooltip" ref={tooltipRef}></div>
            <div>
            
            <Row className="mx-3">
                <Form.Group as={Col}>
                    <Form.Label className="w-20" >１周期辺りのログ取得範囲（デフォルト60秒）</Form.Label>
                    <Form.Control as="select"  className="w-20" id="selectLogRange" onChange={e => setLogRage(Number(e.target.value))}>
                    <option value="60">取得範囲を設定</option>
                    <option value="1">1秒</option>
                    <option value="5">5秒</option>
                    <option value="60">60秒</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="w-20" >再生速度（デフォルト1秒）</Form.Label>
                    <Form.Control as="select" id="selectInterval" className="w-27" onChange={e => setLoopInterval(e.target.value)} >
                        <option value="1000">再生する速度を設定</option>
                        <option value="100">100ミリ秒毎で再生</option>
                        <option value="1000">1秒毎で再生</option>
                        <option value="3000">3秒毎で再生</option>
                        <option value="5000">5秒毎で再生</option>
                    </Form.Control>
                </Form.Group>
            </Row>
            </div>
            <div className="slider-container ">
                <Button className="play-button mt-3 mx-auto mb-2" id="playButton" onClick={() => playFunction(sLoopHandler)}>軌跡を見る</Button>
            </div>
            <div className="card">
                <MoveList listData={moveLists} />
            </div>
        </div>
        )
}

export default Canvas